module.exports = __webpack_public_path__ + "de38dd431be8e30c45e83c511a9b37fb.gif";